module.exports = __webpack_public_path__ + "static/media/03_CALCINHA_ASA_DELTA_02.f55331fd.jpg";